import { API } from 'aws-amplify';
import { TUTORING_URL_APPEND } from 'constants';

export const getTutoringSubjects = async () => {
  const tutoringSubjectList = await API.get(
    'delta-api',
    `${TUTORING_URL_APPEND}subjects`,
    {}
  );
  const { subjects } = tutoringSubjectList;

  return subjects || [];
};

export const getTutoringSubject = async (id) => {
  const tutoringSubjectList = await API.get(
    'delta-api',
    `${TUTORING_URL_APPEND}subjects/${id}`,
    {}
  );
  const { subject } = tutoringSubjectList;

  return subject || [];
};

export const postTutoringSubject = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post('delta-api', `${TUTORING_URL_APPEND}subjects`, myPayload);
};

export const putTutoringSubject = async (payload, id) => {
  const myPayload = {
    body: payload,
  };

  await API.put('delta-api', `${TUTORING_URL_APPEND}subjects/${id}`, myPayload);
};

export const deleteTutoringSubject = async (subjectId) => {
  await API.del('delta-api', `tutoring/subjects/${subjectId}`);
};

export const getTimeSlot = async (subjectId) => {
  const timeSlotData = await API.get(
    'delta-api',
    `tutoring/timeSlot?subjectId=${subjectId}`
  );

  return timeSlotData;
};

export const getBookedSessions = async (
  pageSize,
  paginationKey,
  earliestDate,
  latestDate,
  studentId,
  subjectId,
  ascending,
  includeCancelled
) => {
  const queryStringParameters = {
    limit: pageSize,
    paginationKey: paginationKey,
  };
  if (earliestDate) {
    queryStringParameters.earliestDate = earliestDate;
  }
  if (latestDate) {
    queryStringParameters.latestDate = latestDate;
  }
  if (studentId) {
    queryStringParameters.studentId = studentId;
  }
  if (subjectId) {
    queryStringParameters.subjectId = subjectId;
  }
  if (ascending) {
    queryStringParameters.ascending = ascending;
  }
  if (includeCancelled) {
    queryStringParameters.includeCancelled = includeCancelled;
  }

  const bookedSessions = await API.get(
    'delta-api',
    `${TUTORING_URL_APPEND}sessions?`,
    {
      headers: {},
      queryStringParameters: queryStringParameters,
    }
  );

  return bookedSessions;
};

export const getSession = async (sessionId) => {
  const session = await API.get(
    'delta-api',
    `${TUTORING_URL_APPEND}sessions/${sessionId}`
  );
  return session;
};

export const putSessionStatus = async (payload, sessionId) => {
  const myPayload = {
    body: payload,
  };
  await API.put(
    'delta-api',
    `${TUTORING_URL_APPEND}sessions/${sessionId}/status`,
    myPayload
  );
};

export const putSessionCancel = async (payload, sessionId) => {
  const myPayload = {
    body: payload,
  };
  await API.put(
    'delta-api',
    `${TUTORING_URL_APPEND}sessions/${sessionId}/cancel`,
    myPayload
  );
};

export const getSubjectTimeBlocks = async (subjectId) => {
  const subjectTimeBlocksList = await API.get(
    'delta-api',
    `${TUTORING_URL_APPEND}subjectTimeBlocks?subjectId=${subjectId}`,
    {}
  );

  return subjectTimeBlocksList || [];
};

export const getTimeBlock = async (timeBlockId) => {
  const subjectTimeBlocksList = await API.get(
    'delta-api',
    `${TUTORING_URL_APPEND}subjectTimeBlocks/${timeBlockId}`,
    {}
  );

  return subjectTimeBlocksList || [];
};

export const postSubjectTimeBlock = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${TUTORING_URL_APPEND}subjectTimeBlocks`,
    myPayload
  );
};

export const putSubjectTimeBlock = async (payload, timeBlockId) => {
  const myPayload = {
    body: payload,
  };

  await API.put(
    'delta-api',
    `${TUTORING_URL_APPEND}subjectTimeBlocks/${timeBlockId}`,
    myPayload
  );
};

export const deleteSubjectTimeBlock = async (subjectId) => {
  await API.del(
    'delta-api',
    `${TUTORING_URL_APPEND}subjectTimeBlocks/${subjectId}`
  );
};

export const getTutoringAvailability = async (
  studentId,
  subjectId,
  date,
  overrideLimits
) => {
  const queryStringParameters = {
    studentId: studentId,
    subjectId: subjectId,
    date: date,
    overrideLimits: overrideLimits,
  };
  const tutoringAvailability = await API.get(
    'delta-api',
    `${TUTORING_URL_APPEND}availability?`,
    {
      headers: {},
      queryStringParameters: queryStringParameters,
    }
  );
  return tutoringAvailability;
};

export const postTutoringSession = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post('delta-api', `${TUTORING_URL_APPEND}sessions`, myPayload);
};
